import { StandardPage } from 'src/legacy/components/UI/StandardPage/StandardPage';

export default StandardPage;
